import React from 'react';
import TextField from "material-ui/TextField";
import PropTypes from "prop-types";

const SignalLevelsFields = (props) => {
    const {
        value,
        hasChannelNumbers,
        name,
        channelNumber,
        tapLevelValue,
        tapLevelError,
        groundBlockLevelValue,
        groundBlockLevelError,
        handleValueChange,
    } = props;

    return (
        <div>
            <div className="wow-fst-signal-levels-section-field-name">
                {name}
            </div>
            <div className="wow-fst-signal-levels-section-fields">
                <div className="row">
                    <div className="col s12">
                        {
                            hasChannelNumbers ?
                                <span>Channel Number:      {channelNumber}</span> : null
                        }
                        <TextField
                            fullWidth
                            floatingLabelText="Enter Levels at Tap"
                            value={tapLevelValue}
                            onChange={(e) => handleValueChange(e.target.value, 'tap' + value)}
                        />
                        {
                            tapLevelError ?
                                <span className="wow-fst-signal-levels-section-field-error">
                                    {tapLevelError}
                                </span> :
                                null
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col s12">
                        <TextField
                            fullWidth
                            floatingLabelText="Enter Levels at Ground Block"
                            value={groundBlockLevelValue}
                            onChange={(e) => handleValueChange(e.target.value, 'groundBlock' + value)}
                        />
                        {
                            groundBlockLevelError ?
                                <span className="wow-fst-signal-levels-section-field-error">
                                    {groundBlockLevelError}
                                </span> :
                                null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

SignalLevelsFields.propTypes = {
    value: PropTypes.string,
    hasChannelNumbers: PropTypes.bool,
    name: PropTypes.string,
    channelNumber: PropTypes.string,
    tapLevelValue: PropTypes.string,
    tapLevelError: PropTypes.string,
    groundBlockLevelValue: PropTypes.string,
    groundBlockLevelError: PropTypes.string,
    handleValueChange: PropTypes.func,
};

export default SignalLevelsFields;



// WEBPACK FOOTER //
// ./src/components/signal-levels/SignalLevelsFields.js